import type { ISeoBlockPublicProps } from '../models';

export const collectTree = ({
    links,
    sections,
    subSections,
}: Pick<ISeoBlockPublicProps, 'sections' | 'subSections' | 'links'>) =>
    sections.map(section => {
        const subSectionsWithLinks = (subSections[section.key] ?? []).map(subSection => ({
            ...subSection,
            children: links[subSection.key ?? ''] ?? [],
        }));

        return {
            ...section,
            children: subSectionsWithLinks,
        };
    });

export const isLastItem = <T>(arr: T[], key: number) => key === arr.length - 1;
